export default {
  ga: {
    userId: process.env.REACT_APP_GA__USER_ID || 'UA-70762780-1',
  },
  api: {
    baseUrl: process.env.REACT_APP_API__BASE_URL || 'http://localhost:8080/api/v2', // set this: https://api2.mktmediastats.com/api/v1 as proxy in package.json if CORS is not avaliable
  },
  thematicLab: {
    url: process.env.REACT_APP_THEMATIC_LAB_URL || 'http://localhost:8051',
  },
};
